module.exports = __webpack_public_path__ + "static/media/racquetball.0f26bb1d.jpg";